<template>
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" inline>
        <el-form-item prop="title" label="品牌名称">
          <el-input
            v-model="listForm.title"
            placeholder="请输入品牌名称"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item prop="status" label="状态">
          <el-select v-model="listForm.status" clearable>
            <el-option label="正常" value="1"></el-option>
            <el-option label="关闭" value="0"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="cyan"
            @click="searchProductList"
            >查询</el-button
          >
          <el-button icon="el-icon-search" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="10">
      <el-col :span="1.5" class="add-btn">
        <el-button type="primary" icon="el-icon-plus" @click="addProductBtn"
          >新增品牌</el-button
        >
      </el-col>
    </el-row>
    <el-table
      :data="productList"
      style="width: 100%"
      border
      v-loading="loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="品牌名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="sort"
        label="排序号"
        align="center"
      ></el-table-column>
      <!-- <el-table-column prop="fileUrl" label="品牌图片" align="center">
        <template slot-scope="scope" align="center">
          <img
            v-if="scope.row.fileUrl"
            :src="scope.row.fileUrl"
            width="50"
            height="50"
          />
          <span v-else>未上传</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            :active-value="1"
            :inactive-value="0"
            @change="statusChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column floa="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="editProductBtn(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, sizes, total, jumper"
      :page-sizes="[10, 15, 20]"
      :page-size="listForm.pageSize"
      :total="total"
      :current-page="listForm.pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    ></el-pagination>
    <el-dialog
      :title="title"
      :visible.sync="dialogFormVisible"
      z-index="1000"
      @close="handleDetailClose"
      :close-on-click-modal="false"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        :rules="rules"
        label-width="150px"
      >
        <el-form-item prop="title" label="品牌名称">
          <el-input v-model="dataForm.title"></el-input>
        </el-form-item>
        <el-form-item prop="sort" label="排序号">
          <el-input v-model="dataForm.sort" maxlength="5" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            :class="{ disUoloadSty: noneBtnImg }"
            action=""
            :http-request="uploadFile"
            :on-success="picSuccess"
            list-type="picture-card"
            :limit="limitCountImg"
            :file-list="picList"
            :on-remove="handleImg"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="context" label="品牌简介">
          <div style="line-height: 22px">
            <vue-ueditor-wrap
              id="editor_id"
              v-model="dataForm.context"
              :config="myConfig"
              @beforeInit="addCustomDialog"
            ></vue-ueditor-wrap>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveForm">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogImgVisible" class="img-dialog">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- 品牌简介上传图片 -->
    <el-dialog
      title="上传图片"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="30%"
      :modal-append-to-body="false"
      z-index="3000"
    >
      <el-upload
        class="upload-demo"
        drag
        accept=".png, .jpg"
        action
        :on-success="uploadImageSuccess"
        :http-request="uploadArticleImage"
        style="z-index: 3000"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          只能上传jpg/png文件，且不超过5M
        </div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import {
  addOrEditProDuctIntro,
  getproductIntro,
  uploadBusinessLicence,
  proDuctIntroUpdateStatus,
  getProductDetails,
  uploadImage,
} from "@/common/api.js";
export default {
  components: { VueUeditorWrap },
  data() {
    return {
      listForm: {
        pageSize: 10,
        pageNum: 1,
        title: "",
      },
      dialogVisible: false,
      productList: [],
      total: 0,
      loading: false,
      title: "",
      showBtnImg: true,
      noneBtnImg: false,
      limitCountImg: 5,
      brandImgList: [],
      picList: [],
      dialogImgVisible: false,
      dialogImageUrl: "",
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: true,
        // 初始容器高度
        initialFrameHeight: 300,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/static/UEditor/",
      },
      dialogFormVisible: false,
      isok: true,
      dataForm: {},
      rules: {
        title: [
          { required: true, validator: this.testTitle, trigger: "change" },
        ],
        context: [
          { required: true, message: "请填写品牌简介", trigger: "blur" },
        ],
      },
      checkObj: {
        context: "",
      },
    };
  },
  computed: {},
  watch: {
    dialogFormVisible: {
      handler(newName) {
        if (!newName) {
          this.$refs.dataForm.resetFields();
        }
      },
    },
  },
  methods: {
    addCustomDialog(editorId) {
      let that = this;
      window.UE.registerUI(
        "test-dialog",
        function (editor, uiName) {
          console.log(editor, uiName);
          // 参考http://ueditor.baidu.com/doc/#COMMAND.LIST
          var btn = new window.UE.ui.Button({
            name: "dialog-button",
            title: "上传图片",
            cssRules: `background-position: -381px 0`,
            onclick: function () {
              // 渲染dialog
              that.dialogVisible = true;
              editor.execCommand(uiName);
            },
          });
          return btn;
        },
        100 /* 指定添加到工具栏上的那个位置，默认时追加到最后 */,
        editorId /* 指定这个UI是哪个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮 */
      );
    },
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      getproductIntro(params).then((res) => {
        console.log("res :>> ", res);
        this.loading = false;
        if (res.errorCode == 200) {
          this.productList = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 图片预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogImgVisible = true;
    },
    // 点击新增
    addProductBtn() {
      this.dialogFormVisible = true;
      this.title = "新增品牌";
      this.noneBtnImg = false;
    },
    //点击编辑
    editProductBtn(row) {
      console.log(row);
      this.title = "编辑品牌";
      this.dialogFormVisible = true;
      var params = {
        id: row.id,
      };
      getProductDetails(params).then((res) => {
        if (res.errorCode == 200) {
          this.dataForm = {
            id: res.id,
            title: res.title,
            context: res.context,
            sort: res.sort,
          };
          if (res.imgList) {
            for (let k = 0; k < res.imgList.length; k++) {
              this.picList.push({
                url: res.imgList[k].fileUrl,
              });
              this.brandImgList.push({
                fileUrl: res.imgList[k].fileUrl,
              });
            }
            console.log(this.brandImgList);
          }
          this.noneBtnImg = this.picList.length >= this.limitCountImg;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 图片上传成功
    picSuccess(res, file, fileList) {
      this.noneBtnImg = fileList.length >= this.limitCountImg;
      console.log(fileList);
      if (res.errorCode == 200 && fileList.length > 0) {
        this.brandImgList = [];
        fileList.forEach((item) => {
          if (item.response) {
            this.brandImgList.push({
              fileUrl: item.response.url,
            });
          } else {
            this.brandImgList.push({
              fileUrl: item.url,
            });
          }
        });
      }
    },
    // 删除图片
    handleImg(file, fileList) {
      this.noneBtnImg = fileList.length >= this.limitCountImg;
      console.log(fileList);
      if (fileList.length > 0) {
        this.brandImgList = [];
        fileList.forEach((item) => {
          if (item.response) {
            this.brandImgList.push({
              fileUrl: item.response.url,
            });
          } else {
            this.brandImgList.push({
              fileUrl: item.url,
            });
          }
        });
      } else {
        this.brandImgList = [];
      }
    },
    //弹窗关闭
    handleDetailClose() {
      this.dataForm = {};
      this.picList = [];
    },
    saveForm() {
      console.log(this.brandImgList);
      this.$refs.dataForm.validate((valid) => {
        if (valid && this.isok) {
          this.dataForm.imgList = this.brandImgList;
          var params = this.dataForm;
          addOrEditProDuctIntro(params).then((res) => {
            if (res.errorCode == 200) {
              this.dialogFormVisible = false;
              this.getPageList();
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          if (!this.isok) {
            this.$message.error("限制字数为600(包括标点符号)");
          }
          return false;
        }
      });
    },
    statusChange(row) {
      console.log(row);
      var department = row.title;
      var mess = "";
      let text = "";
      if (row.status == 1) {
        text = "有效";
      } else if (row.status == 0) {
        text = "无效";
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h(
            "h3",
            null,
            '是否将 "' + department + '" 的状态变为 "' + text + '" ?',
            "警告"
          ),
          h("h4", { style: "color:#a0a0a0" }, mess),
        ]),
        showCancelButton: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              id: row.id,
              status: row.status,
            };
            proDuctIntroUpdateStatus(params).then((res) => {
              if (res.errorCode == "200") {
                this.getPageList();
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.status == 1) {
                  row.status = 0;
                } else if (row.status == 0) {
                  row.status = 1;
                }
              }
            });
          } else {
            done();
            if (row.status == 1) {
              row.status = 0;
            } else if (row.status == 0) {
              row.status = 1;
            }
            console.log(row.status);
          }
        },
      })
        .then((action) => {
          console.log();
        })
        .catch(() => {
          console.log();
        });
    },
    beforeUpload(file) {
      var types = ["image/jpg", "image/jpeg", "image/png"];
      var isImage = types.includes(file.type);
      var isLtSize = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error("上传图片仅支持 JPG、PNG 格式!");
        return false;
      }
      if (!isLtSize) {
        this.$message.error("上传图片大小不能超过 5MB!");
        return false;
      }
      return true;
    },
    uploadFile(file) {
      let formDatas = new FormData();
      formDatas.append("businessLicence", file.file);
      uploadBusinessLicence(formDatas).then((res) => {
        if (res.errorCode == 200) {
          file.onSuccess(res);
        }
      });
    },
    uploadImageSuccess(response, file, fileList) {
      if (response) {
        this.$message({
          message: "上传成功",
          type: "success",
        });
        let fileObj = {
          name: file.name,
          url: file.response,
        };
        this.insertUe(fileObj);
      } else {
        this.$message({
          message: "上传失败",
          type: "warning",
        });
      }
    },
    uploadArticleImage(file) {
      let formDatas = new FormData();
      formDatas.append("businessLicence", file.file);
      uploadImage(formDatas).then((res) => {
        if (res.errorCode == 200) {
          file.onSuccess(res.url);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    insertUe(file) {
      let editor = document.querySelector(".edui-default").getAttribute("id");
      console.log(file);
      window.UE.getEditor(editor).execCommand("insertimage", {
        src: file.url,
        width: "100",
        height: "100",
      });
      this.dialogVisible = false;
    },
    searchProductList() {
      this.listForm.pageNum=1;
      this.getPageList();
    },
    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    },
    testTitle(rule, value, callback) {
      if (value) {
        if (value.length > 20) {
          callback(new Error("最多输入20个字符"));
        }
        var str =
          /[`~!@#$%^&*()_\-+=<>?:"{}|,.\ \/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
        if (value.match(str)) {
          callback(new Error("不能输入特殊字符"));
        }
        callback();
      } else {
        callback(new Error("请输入企业名称"));
      }
    },
    // 搜索框重置
    reset() {
      this.$nextTick(() => {
        this.$refs["listForm"].resetFields();
        this.getPageList();
      });
    },
  },
  created() {},
  mounted() {
    this.getPageList();
  },
  filters: {
    status(value) {
      switch (value) {
        case 0:
          return "关闭";
          break;
        case 1:
          return "正常";
          break;
      }
    },
  },
};
</script>
<style lang='less' scoped>
.wrapper {
  width: 100%;
  height: 100%;
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  .el-row {
    margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
  }

  .img-dialog /deep/.el-dialog__header {
    padding: 20px 20px 10px;
    background-color: #ffffff;
    border-style: none;
  }
  /deep/.el-input__inner,
  /deep/.searchconditions .el-form-item__content {
    height: 34px;
    line-height: 34px;
  }
  /deep/.el-input__icon,
  /deep/.el-form-item__label {
    line-height: 34px;
  }
  .el-form-item .el-select {
    width: 100%;
  }
  /deep/.uoloadSty .el-upload--picture-card {
    display: inline-block;
  }
  /deep/.disUoloadSty .el-upload--picture-card {
    display: none; /* 上传按钮隐藏 */
  }

  .image {
    display: inline-block;
    width: 160px;
    img {
      width: 160px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/scanManage/brandPromotion.vue